import { useSelector } from 'react-redux';

import { makeGetLoginType } from 'selectors/auth';

import { loginPolicies, loginTypes } from 'utils/team';

const getLoginType = makeGetLoginType();

export const useCanLogin = ({ team }) => {
    const loginType = useSelector(({ auth }) => getLoginType(auth));

    const loginPolicy = team?.login_policy;
    const isOwner = team?.current_user_is_owner;
    const isClient = team?.current_user_is_client;

    if (!loginPolicy || isOwner || isClient) {
        return true;
    }

    if (loginPolicy === loginPolicies.TFA) {
        return loginType === loginTypes.TFA;
    }

    if (loginPolicy === loginPolicies.ANY_SSO) {
        return [loginTypes.GOOGLE, loginTypes.MICROSOFT].includes(loginType);
    }

    if (loginPolicy === loginPolicies.GOOGLE) {
        return loginType === loginTypes.GOOGLE;
    }

    if (loginPolicy === loginPolicies.MICROSOFT) {
        return loginType === loginTypes.MICROSOFT;
    }

    return false;
}
